import * as Yup from 'yup';

const schema = Yup.object().shape({
  Acronym: Yup.string().required('O campo deve ser preenchido'),
  StageName: Yup.string().required('O campo deve ser preenchido'),
})

export default schema;